import React, { } from 'react';
import Tabs, { TabsProps, TabItem } from './Tabs';

/**
 * TabsAdapter component is a wrapper around the Tabs component
 * that allows it to work with simple tab items that don't have content.
 * 
 * It accepts tab items similar to SimpleTabs, but has the same API
 * as the regular Tabs component.
 */
export interface TabsAdapterProps extends Omit<TabsProps, 'tabs'> {
  tabs: Omit<TabItem, 'content'>[];
  activeTab: string;
  onChange: (tabId: string) => void;
}

const TabsAdapter: React.FC<TabsAdapterProps> = ({
  tabs,
  activeTab,
  onChange,
  ...restProps
}) => {
  // Convert the simple tabs to full tabs with empty content
  const fullTabs = tabs.map(tab => ({
    ...tab,
    content: <div></div> // Empty content as a placeholder
  }));

  // Return the Tabs component with the enhanced tabs
  return (
    <Tabs
      tabs={fullTabs}
      defaultTab={activeTab}
      onChange={onChange}
      {...restProps}
    />
  );
};

export default TabsAdapter;